import { AuthStateModel, LoginAction, LogoutAction } from './auth.state.model';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { AppActions } from '../../app.actions';
import { Editor } from '../../editor/editor.model';
import { environment } from '../../../environments/environment';

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    isAuthenticated: false,
    token: null,
    editor: null
  }
})

@Injectable()
export class AuthState {
  private store = inject(Store);
  private authService = inject(AuthService);
  private router = inject(Router);

  @Selector()
  static getToken(state: AuthStateModel): string | null {
    return state.token;
  }

  @Selector()
  static getIsAuthenticated(state: AuthStateModel): boolean {
    return !!state.token;
  }

  @Selector()
  static getEditor(state: AuthStateModel): Editor | null {
    return state.editor;
  }

  @Action(AppActions.RestoreAuthState)
  restoreAuthState(ctx: StateContext<AuthStateModel>) {
    const isAuthenticated = sessionStorage.getItem('isAuthenticated') !== null;
    const editor = JSON.parse(sessionStorage.getItem('editor') || 'null');

    // Patch the state directly in this action
    ctx.patchState({
      isAuthenticated,
      token: sessionStorage.getItem('access_token'),
      editor
    });
  }

  @Action(LoginAction)
  login(ctx: StateContext<AuthStateModel>, action: LoginAction) {
    this.authService.login(action.payload).subscribe({
      next: (dto) => {
        sessionStorage.setItem('access_token', dto.token);
        sessionStorage.setItem('editor', JSON.stringify(dto.user));

        ctx.patchState({
          isAuthenticated: true,
          token: dto.token,
          editor: JSON.parse(sessionStorage.getItem('editor') || 'null'),
        });

        this.store.dispatch(new AppActions.LoadInitialData());
        this.router.navigate(['/dashboard']);
      },
    });
  }

  @Action(LogoutAction)
  logout(ctx: StateContext<AuthStateModel>) {
    function internalLogout(router: Router) {
      router.navigate(['/login']);

      ctx.setState({
        isAuthenticated: false,
        token: null,
        editor: null,
      });

      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('editor');
      sessionStorage.removeItem('isAuthenticated');
    }
    this.authService
      .logout()
      .subscribe({
        next: () => {
          if (!environment.isProd) {
            console.log('Server logout successful');
            internalLogout(this.router);
          }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error: (err: any) => {
          internalLogout(this.router);

          if (!environment.isProd) {
            console.warn('Server logout not successful with error ', err);
          }
        },
      });
  }
}
